module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/influencers/influencer-merch-title-f809a2deabd3db0878a558199b7fc3a2.svg";